export const getPointsDiscountImage = (multiplier) => `/static/images/notifications/x${ multiplier }.svg`;
